<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent>
    <v-card>
      <v-card-title v-if="selected && selected.type">
        <back-button color="grey" @click="close" />
        {{ `${selected.type.name}: ${selected.name}` }}
      </v-card-title>
      <v-card-title v-else>
        <back-button color="grey" @click="close" />
        Par de Diagnóstico
      </v-card-title>
      <v-card-text class="my-5">
        <tracking-impaction-point-input-sides
          v-if="selected"
          :key="selected.id"
          :value="sides"
          :tracking-point="selected.points.trackingPoint"
          :impaction-point="selected.points.impactionPoint"
          class="grey"
          @input="
            (value) => setValuesDiagnosePar({ value, property: 'pointsSides' })
          "
        />
        <property-value
          v-if="selected.description"
          property="Descrição"
          :value="selected.description"
        />
        <property-value
          v-if="selected.recommendations"
          property="Recomendações"
          :value="selected.recommendations"
        />
        <select-par-properties
          v-model="diagnosePar.symptoms"
          label="Sintomas"
          :items="selected.symptoms"
        />
        <v-switch
          v-model="hidePatient"
          :value="hidePatient"
          label="Esconder ao paciente na diagnose"
        />
        <v-switch
          v-model="patientImpactAtHome"
          :value="patientImpactAtHome"
          label="Recomendar ao paciente impactar em casa"
        />

        <Comments v-model="comments" />
      </v-card-text>
      <div class="mt-5 d-flex flex-column">
        <v-btn color="secondary" x-large @click="addToDiagnose">
          Adicionar ao Diagnóstico
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    Comments: () =>
      import("@/domains/therapy/shared/presentation/components/Comments"),
  },
  data: () => ({
    diagnosePar: {},
    comments: {},
    sides: {},
    hidePatient: false,
    patientImpactAtHome: false,
  }),
  computed: {
    dialog: {
      get() {
        return this.$store.state.dialogs.dynamicPairType;
      },
      set(value) {
        this.$store.commit("dialogs/setDynamicPairType", value);
      },
    },
    selected() {
      console.log("selected", this.$store.state.dynamicPairType);
      return this.$store.state.dynamicPairType.selected;
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    setValuesDiagnosePar(value) {
      this.sides = value;
    },
    async addToDiagnose() {
      try {
        const { therapistComments, patientComments } = this.comments;
        const { trackingPointSide, impactionPointSide } = this.sides;

        const diagnosePar = {
          therapistComments,
          patientComments,
          ...this.diagnosePar,
          par: {
            ...this.selected,
          },
          trackingPointSide,
          impactionPointSide,
          hidePatient: this.hidePatient,
          patientImpactAtHome: this.patientImpactAtHome,
        };

        await this.$store.dispatch("diagnosis/addParToDiagnose", diagnosePar);
        this.$toasted.global.success({
          message: "Par adicionado ao diagóstico",
        });
        this.dialog = false;
      } catch (error) {
        this.$toasted.global.error({
          message: error.message
            ? error.message
            : "Erro interno ao adicionar ao diagnóstico",
        });
      }
    },
  },
};
</script>

<style scoped></style>
